import { PlandetailsMasterComponent } from './master/Plandetails/plandetails.component';
import { SeasonMasterComponent } from './master/Season/season.component';
import { AddEditSeasonComponent } from './master/Season/addEditSeason.component';
import { SalesPlanReport } from './report/salesplanreport/salesplanreport.component';
import { AddEditSalesPlanReport } from './report/salesplanreport/addEditSalesplan.component';
import { PhotoDialog } from './report/DesignPhotos/photos.component';
import { AgentYearlyReport } from './report/AgentYearlyReport/AgentYearlyReport';
import { AgentSeasonalReport } from './report/AgentSeasonalReport/AgentSeasonalReport';
import { PartySalesOrderReport } from './report/PartySalesOrderReport/PartySalesOrderReport';
import { SeasonTargetReport } from './report/SeasonTargetReport/seasontarget.component';
import { PartySalesQtyReport } from './report/PartyOrderQty/PartyOrderQtyReport';
import { DesignWiseSOReport } from './report/DesignWiseSOReport/DesignWiseSOReport';
import { Table2 } from '../common/table2/table2.component';
import { Table3 } from '../common/table3/table3.component';
import { AgGridComponent } from '../common/ag-grid/ag-grid.component';
import { DesignTile } from '../common/designtile/designtile.component';
import { fairStock } from './Purchase/sample/fairStock'
import { stocktransfer } from './Purchase/sample/stocktransfer'
import { stockUpdate } from './Purchase/sample/stockUpdate';
import { NonOrderedParty } from './report/NonOrderedParty/NonOrderedParty';
import { NewPartyReport } from './report/NewPartyReport/NewPartyReport';
import { NonOrderedDesignReport } from './report/NonOrderedDesignReport/NonOrderedDesignReport';
import { sampleFair } from './Purchase/sample/sampleFair'
import { InactivePartyReport } from './report/InactivePartyReport/InactivePartyReport';
import { sampleFairReport } from './Purchase/sampleReport/sampleFairReport'
import { PartySeasonalReport } from './report/PartySeasonalReport/PartySeasonalReport';
import { StockReport } from './report/StockReport/StockReport';
import { SalesInvoiceAgent } from './report/DeliveryReport/DeliveryReport';
import { DesignWiseSalesOrderReport } from './report/SalesOrderReports/salesOrderReport/SoReport.component';
import { DesignDataComponent } from './master/DesignData/DesignData';
// import { OrderVsTargetReport } from './report/comparison/ordervstarget/orderTarget.component';
// import { OrderAgainstInvoice } from './report/comparison/OrderAgainstInvoiceReport/OrderAgainstInvoiceReport.component';
import { SalesOrderReport } from './report/OrderwiseReport/SalesOrder';
import { SalesOrderDetailsReport } from './report/OrderwiseReport/SalesOrderdetails';
import { SalesInvoiceReport } from './report/salesReport/SalesInvoice';
import { SalesInvoiceDetailsReport } from './report/salesReport/SalesInvoicedetails';
import { DcReport } from './report/DcReport/DcReport.component';
import { continuosNumber } from './report/continuosNumber/continuosNumber';
import { designWiseOrderPlacing } from './report/designWiseOrderPlacing/designWiseOrderPlacing';
import { MenuMapping } from './master/menuMapping/menuMapping.component';
import { PurchaseInvoiceComponent } from './Purchase/invoice/invoice.component';
import { AddEditInvoice } from './Purchase/invoice/addEditInvoice.component';
import { PurchaseOrderComponent } from './Purchase/purchaseOrder/purchaseOrder';
import { AddEditPurchaseOrder } from './Purchase/purchaseOrder/addEditPurchaseOrder';
import { POCancelComponent } from './Purchase/poCancel/poCancelList';
import { AddEditPOCancel } from './Purchase/poCancel/addEditPOCancel';
import { LorryInvoice } from './Purchase/lorryDetails/lorry';
import { AddEditLorryInvoice } from './Purchase/lorryDetails/addEditlorry';
import { PurchaseOrderReport } from './Purchase/purchaseOrderReport/poReport';
import { purchaseOrderStatusReport } from './Purchase/purchaseOrderReport/poStatusReport';
import { fabricBendingReport } from './Purchase/purchaseOrderReport/fabricBendingReport';
import { swatchWoReport } from './Purchase/purchaseOrderReport/swatchWoReport';

import { PurchaseInvoiceReport } from './Purchase/LRinvoiceReport/invoicereport.component';
import { LRInvoiceReport } from './Purchase/lorryReport/lorryReport';
import { OrderVsInvoiceReport } from './Purchase/ordervsinvoice/OrderVsInvoice';
import { AddEditGrn } from './Purchase/grn/addEditGrn';
import { GrnListComponent } from './Purchase/grn/grn';
import { AddEditJGRN } from './Purchase/jgrn/AddEditJGRN';
import { JGRNComponent } from './Purchase/jgrn/JGRN';
import { LorryUpdate } from './Purchase/lorryUpdate/lorryUpdate';
import { AddEditLorryUpdate } from './Purchase/lorryUpdate/addEditLorryUpdate';

/* import { LorryReceiveDetails } from './Purchase/lorryUpdate/lorryUpdate';
import { UpdateRecDetails } from './Purchase/lorryUpdate/updateRecDet'; */
// import { LRVsGRNReport } from './Purchase/LRagainstGRN/LRvsGRN';
import { GrnReport } from './Purchase/grnReport/grnReport';
import { PurchaseReturnComponent } from './Purchase/purchaseReturn/purchaseReturn';
import { AddEditPurchaseReturn } from './Purchase/purchaseReturn/addEditPurchaseReturn';
import { PurchaseStockReport } from './Purchase/purchaseStockReport/pstockReport';
import { DCComponent } from './Purchase/Dccutting/dcCutting';
import { AddEditDC } from './Purchase/Dccutting/addEditDc';
import { fabricPrint } from './Purchase/fabricPrint/fabricPrint';
import { SampleComponent } from './Purchase/sample/sample';
import { AddEditSample } from './Purchase/sample/addEditSample';
import {AddEditcreateSample} from './Purchase/sample/AddEditcreateSample';
import { WorkOrderComponent } from './Purchase/workorder/workOrder';
//import { woprint } from './Purchase/workorder/woprint';
import { AddEditWorkOrder } from './Purchase/workorder/addEditWorkOrder';
import { ActualCuttingComponent } from './Purchase/actualcutting/actualCutting';
import { AddEditActualCutting } from './Purchase/actualcutting/addEditActualCutting';
import { addEditRgrn } from './Purchase/rgrn/addEditRgrn'
import { SampleReport } from './Purchase/sampleReport/sampleReport';
import { ClothDCReport } from './Purchase/dcReport/clothdcReport';
import { NewPurchaseReport } from './Purchase/newReport/newPurchaseReport';
import { AgentWiseReport } from './Purchase/agentWiseReport/agentWiseReport';
import { SampleGrnStockReport } from './Purchase/sampleGrnStockReport/sampleGrnStockReport';
import { CostingSample } from './Purchase/costingSample/costingSample';
import { CostingList } from './Purchase/costingSample/costingList';
import { WOReport } from './Purchase/workOrderReport/woReport';
import { agewiseworeport } from './Purchase/woreports/agewiseworeport';
// import { stocktransferreport } from './Purchase/woreports/stocktransferreport';
import { CoreprocessReport } from './Purchase/woreports/CoreprocessReport';
import { woFabricDeliveryPending } from './Purchase/woreports/woFabricDeliveryPending';
import { cuttingdetailsreport } from './Purchase/woreports/cuttingdetailsreport';
import { woprocessreport } from './Purchase/woreports/woprocessreport';
import { factoryStockreport } from './Purchase/woreports/factoryStockreport';
import { monthwisewo } from './Purchase/woreports/monthwisewo';
import { SwatchComponent } from './Purchase/swatch/swatch';
import { AddEditSwatch } from './Purchase/swatch/swatchDetails';
import { SwatchReport } from './Purchase/swatchReport/swatchReport';
import { SwatchPendingReport } from './Purchase/swatchPendingReport/swatchPendingReport';
import { CuttingReport } from './Purchase/cuttingReport/cuttingReport';
import { CostingSampleReport } from './Purchase/costReport/costSampleReport';
import { WOVsCuttingReport } from './Purchase/WOVsCutting/WOVsCutting';
import { UserComponent } from './master/User/user';
import { AddEditUser } from './master/User/addEditUser';
import { DesignStock } from './master/DesignStock/designStock';
import { AddEditDesignStock } from './master/DesignStock/addEditdesignStock';
import { DesignList } from './master/DesignList/designList';
import { AddEditDesignList } from './master/DesignList/addEditdesignList';
import { SalesOrderComponent } from './Sales/salesOrder/salesOrder';
import { brandStockComponent } from './Sales/brandStockInward/brandStock';
import { AddEditSalesOrder } from './Sales/salesOrder/addEditSalesOrder';
import { addEditBrandStock} from './Sales/brandStockInward/addEditBrandStock';
import { SalesInvoiceReturn } from './Sales/salesReturn/salesReturn';
import { salesReturnBundle } from './Sales/salesReturn/salesReturnBundle';
import { AddEditSalesReturn } from './Sales/salesReturn/addEditSalesReturn';
import { addEditSalesReturnBundle } from './Sales/salesReturn/addEditSalesReturnBundle';
import { addEditCommission } from './Sales/commissionMaster/addEditCommission';
import { commissionMaster } from './Sales/commissionMaster/commissionMaster';
import { addEditAgentpayment} from './Sales/agentPayment/addEditAgentpayment';
import { agentPaymentEntry } from './Sales/agentPayment/agentPaymentEntry';
// import { SalesReplacement } from './Sales/salesReplacement/salesReplacement';
// import { AddEditSalesReplacement } from './Sales/salesReplacement/addEditSalesReplacement';
import { PartyComponent } from './master/party/party';
import { AddEditParty } from './master/party/addEditParty';
import { ViewReprintBarcodeComponent } from './master/ViewReprintBarcode/viewReprintBarcode';
import { SalesInvoiceComponent } from './Sales/salesInvoice/salesInvoice';
import { AddEditSalesInvoiceComponent } from './Sales/salesInvoice/addEditInvoice';
import { SampleInwardComponent } from './Sales/Inward/inwardList';
import { InwardEntryComponent } from './Sales/Inward/addEditInward';
import { DcComponent } from './Sales/Dc/dcList';
import { DcEntryComponent } from './Sales/Dc/addEditDc';
import { PrintData } from './master/print/print';
import { CoreDesignReport } from './Purchase/coredesignReport/coreDesignReport';
import { addCoreGang } from './Purchase/coreGangMaster/addCoreGang';
import { coreGangMaster } from './Purchase/coreGangMaster/coreGangMaster';
import { coreStockReport } from './Purchase/coredesignReport/coreStockReport'
import { PrintWorkOrder } from './Purchase/workorder/printWO';
import { PrintLRData } from './Purchase/lorryDetails/print';
import { PartyInvoiceReport } from './Purchase/partyInvoiceReport/partyinvoicereport.component';
import { GrnColorReport } from './Purchase/grncolorReport/grncolorreport.component';
import { SampleStockReport } from './Purchase/sampleStockReport/samplestockreport.component';
import { POVsGRNReport } from './Purchase/POagainstGRN/POvsGRN';
// import { JgrnStockReport } from './Purchase/jgrnStockReport/jgrnStockReport';
import { SamplePrint } from './Purchase/sample/samplePrint';
import { workorderprint } from './Purchase/workorder/woprint';
import { RgrnComponent } from './Purchase/rgrn/RgrnComponent';
import { partysalesvalueReport } from './salesReports/partysalesvalueReport';
import { partysalespcsReport } from './salesReports/partysalespcsReport';
import { deliverypendingReport } from './salesReports/deliverypendingReport/deliverypending';
import { salesReport } from './salesReports/salesReport';
import { monthSalesReport } from './salesReports/monthSalesReport';
import { from } from 'rxjs/observable/from';
import { agentSalesReport } from './salesReports/agentSalesReport';
import { mrpSalesReport } from './salesReports/mrpSalesReport';
import { salesReturnReport } from './salesReports/salesReturnReport';
// import { OFSReportComponent } from './reportlist/order-form-stock/ofs.component';
import { LRSReportComponent } from './reportlist/lr-stock/lrs.component';
import { BundleReportComponent } from './reportlist/bundle-stock/bundle.component';
import { invoiceVsGrn } from './Purchase/purchaseOrderReport/invoiceVsGrn';
// import { poBulkPending } from './Purchase/poBulkPending/poBulkPending';
import { sampleInward } from './Purchase/sample/sampleInward';
import { sampleRemainReport } from './Purchase/purchaseOrderReport/sampleRemainReport';
import { sampleDcReport } from './Purchase/purchaseOrderReport/sampleDcReport';
// import { dgrnComponent } from './Purchase/dgrn/dgrnComponent';
// import { addEditDgrn } from './Purchase/dgrn/addEditDgrn';
// import { workActualDgrn } from './Purchase/woreports/workActualDgrn';
import { verifySalesOrder } from './Sales/salesOrder/verifySalesOrder';
import { verifyEstimate } from './Sales/salesInvoice/verifyEstimate';
import { estimateBundle } from './Sales/salesInvoice/estimateBundle';
import { verifiedEstimate } from './Sales/salesInvoice/verifiedEstimate';
import { printCutting } from './Purchase/actualcutting/printCutting';
import { printFairSample } from './Purchase/sample/printFairSample';
// import { rackStock } from './Purchase/RackTransfer/rackStock';
// import { rackList } from './Purchase/RackTransfer/rackList';
// import { rackTransList } from './Purchase/RackTransfer/rackTransList';
// import { rackTrans } from './Purchase/RackTransfer/rackTrans';
// import { rackStockReport } from './Purchase/woreports/rackStockReport';
import { designSoReport } from './report/SalesOrderReports/designSoReport/designSoReport';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { styleSoReport } from './report/SalesOrderReports/designSoReport/styleSoReport';
import { designDeliveryReport } from './salesReports/designDeliveryReport';
import { designVsOrderReport } from './salesReports/designVsOrderReport';
import { partyOrderReport } from './report/SalesOrderReports/partyOrderReport/partyOrderReport';
import { coreDesignStockReport } from './salesReports/coreDesignStockReport';
import { newDesignStockReport } from './salesReports/newDesignStockReport';
import { coreStatusReport } from './report/SalesOrderReports/coreGangReport/coreStatusReport';
import { SalesInvoiceReportComponent } from './salesReports/sales-invoice-report/SalesInvoiceReportComponent';
import { designSoStockReport } from './report/designSoStockReport/designSoStockReport';
// import { rdAgainstReport } from './Purchase/woreports/rdAgainstReport';
import { fabricStockTransfer } from './Purchase/sample/fabricStockTransfer';
import { overAllStockReport } from './salesReports/overAllStockReport';
import {  partyNewJoineeReport } from './salesReports/PartyNewJoineeReport';
import {  partyInactiveReport } from './salesReports/partyInactiveReport';
import { woVsStockReport } from './Purchase/workOrderReport/woVsStockReport';
import { workActualRgrn } from './Purchase/woreports/workActualRgrn';
import { agentOutwardComponent } from './Sales/agentOutward/agentOutward';
import { addEditAgentOutwardComponent } from './Sales/agentOutward/addEditAgentOutward';
import { agentInwardComponent } from './Sales/agentInward/agentInward';
import { addEditAgentInwardComponent } from './Sales/agentInward/addEditAgentInward';
// import { mismatchList } from './Purchase/grn/mismatchList';
import { workOrderInward } from './Purchase/workorder/workOrderInward/workOrderInward';
import { addEditWorkOrderInward } from './Purchase/workorder/workOrderInward/addEditWorkOrderInward';
import { pcswiseAnnualReport } from "./salesReports/pcswiseAnnualReport";
import { valuewiseAnnualReport } from "./salesReports/valuewiseAnnualReport";
import { agentStockReport } from "./salesReports/agentStockReport";
import { invoiceReturnReport } from './salesReports/invoiceReturnReport';
import { seasonWiseAnnualReport } from "./salesReports/seasonWiseAnnualReport";
import { seasonWiseValueAnnualReport } from "./salesReports/seasonWiseValueAnnualReport";
import { DamageInvoiceComponent } from './Sales/damageInvoice/damageInvoice';
import { AddEditDamageInvoiceComponent } from './Sales/damageInvoice/addEditDamageInvoice';
import { oliveInvoiceComponent } from './Sales/oliveInvoice/oliveInvoice';
import { AddEditOliveInvoiceComponent } from './Sales/oliveInvoice/addEditOliveInvoice';
import { jobInvoiceComponent } from './Sales/jobInvoice/jobInvoice';
import { AddEditJobInvoiceComponent } from './Sales/jobInvoice/addEditJobInvoice';
import { WoReturnComponent } from './Purchase/workorder/woReturn';
import { salesOrderReport } from './report/SalesOrderReports/salesOrderReport/salesOrderReport';
import { AddEditEstiWorkOrder } from './Purchase/workorder/addEditEstiWorkOrder';
import { verifiedestimatewoComponent } from './Purchase/workorder/verifiedEstimateWo';
import { MatchDCComponent } from './Purchase/Dccutting/matchdcCutting';
 import { AddEditMatchDC } from './Purchase/Dccutting/addEditMatchDc';
 import { lrGrnVerification } from './Purchase/lrGrnVerification/lrGrnVerification';
 import { salesPlanMasterReport } from './master/salesPlanMasterReport/salesPlanMasterReport';
 import { salesPlanEntry } from './master/salesPlanMasterReport/salesPlanEntry';
 import { monthSalesOrderReport } from './report/SalesOrderReports/MonthSOReport/monthSalesOrderReport';
import { mrpSalesOrderReport } from './report/SalesOrderReports/MrpSOReport/mrpSalesOrderReport';
import { POSampleReport } from './Purchase/POStatusReports/poSampleReport/poSampleReport';
import { PoSwatchReport } from './Purchase/POStatusReports/poSwatchReport/poSwatchReport';
import { charts } from './Purchase/woreports/charts';
import { SampleCancelReport } from './Purchase/sampleReport/sampleCancelReport';
import { SampleReturn } from './Purchase/sample/sampleReturn';
import { addEditSampRet } from './Purchase/sample/addEditSampRet';
import { mrpSampleReport } from './Purchase/sampleReport/mrpSampleReport';
import { estimateWoReport } from './Purchase/woreports/estimateWoReports';
import { approvedWorkOrder } from './Purchase/workorder/approvedWorkOrder';
import { approvedWoReport } from './Purchase/woreports/approvedWoReport';
import { SampleReturnInward } from './Purchase/sample/sampleReturnInward';
import { estimateStockReport } from './salesReports/sales-invoice-report/estimateStockReport';
import { matchingDesignList } from './Purchase/matchingDesignList/matchingDesignList';
import { matchDesignList } from './Purchase/matchingDesignList/matchDesignList';
import { sampleToBitConvertGrn } from './Purchase/sampleToBitConvertGrn/sampleToBitConvertGrn';
import { addEditsampleToBitConvertGrn } from './Purchase/sampleToBitConvertGrn/addEditsampleToBitConvertGrn';
// import { barcodeHistory } from './report/barcodeHistory/barcodeHistory';
import { shirtStockReport } from './report/shirtStockReport/shirtStockReport';
import { corePendingOrder } from './salesReports/corePendingOrder/corePendingOrder';
import { convertShirtTypes } from './master/convertShirtTypes/convertShirtTypes';
import { shirtTypeupdate } from './master/convertShirtTypes/shirtTypeupdate';

import { woreturnInwardReport } from './Purchase/woreports/woreturnInwardReport/woreturnInwardReport';
import { researchToWarehouseTextileDc } from './Purchase/researchToWarehouseTextileDc/researchToWarehouseTextileDc';
import { researchDcList } from './Purchase/researchToWarehouseTextileDc/researchDcList';
import { researchDcReport } from './Purchase/sampleReport/researchDcReport';
import { cuttingPlan } from './Purchase/workorder/cuttingPlan';
import { cuttingPlanPrint } from './Purchase/workorder/cuttingPlanPrint';
import { ff_cp_report} from './Purchase/woreports/ff_cp_report';
import { designUpload } from './master/designUpload/designUpload';
import { orderFormDesignPhoto } from './salesReports/orderFormDesignPhoto/orderFormDesignPhoto';
import { designPhotoList } from './master/designPhotoList/designPhotoList';
import { bitFabricStock } from './Purchase/bitStock/bitFabricStock';
import { addEditBitStock} from './Purchase/bitStock/addEditBitStock';
import { bitStockReport} from './Purchase/bitStockReport/bitStockReport';
import { bitCurrentStock } from './Purchase/bitStockReport/bitCurrentStock';
import { factoryReport } from './Purchase/woreports/factoryReport/factoryReport';
import { fmDcApproval } from './Purchase/workorder/fmDcApproval';
import { woDelivery } from './Purchase/woDelivery/woDelivery';
import { addEditWoDelivery } from './Purchase/woDelivery/addEditWoDelivery';
import { woDelFmApproval } from './Purchase/workorder/woDelFmApproval/woDelFmApproval';
import { woDelRdApproval } from './Purchase/workorder/woDelRdApproval/woDelRdApproval';
import { balanceBitInward } from './Purchase/workorder/balanceBitInward/balanceBitInward';
import { ocrPrint } from './Purchase/workorder/woDelFmApproval/ocrPrint';
// import { productionStore } from './Purchase/workorder/productionStore/productionStore';
// import { fusing } from './Purchase/workorder/factory/fusing/fusing';
// import { frontAndRecutting } from './Purchase/workorder/factory/frontAndRecutting/frontAndRecutting';
// import { stitching } from './Purchase/workorder/factory/stitching/stitching';
// import { kajaAndButton } from './Purchase/workorder/factory/kajaAndButton/kajaAndButton';
// import { fusingPrint } from './Purchase/workorder/productionStore/fusingPrint/fusingPrint';
// import { frPrint } from './Purchase/workorder/productionStore/frPrint/frPrint';
// import { stitchingPrint } from './Purchase/workorder/productionStore/stitchingPrint/stitchingPrint';
// import { kbPrint } from './Purchase/workorder/productionStore/kbPrint/kbPrint';
import { bitDc } from './Purchase/bitDc/bitDc';
import { addEditBitDc } from './Purchase/bitDc/addEditBitDc';
import { bitDcPrint } from './Purchase/bitDc/bitDcPrint';
import { openOrderReport } from './salesReports/openOrderReport/openOrderReport';
import { scrapBitStock } from './Purchase/scrapBit/scrapBitStock';
import { scrapBitOutward } from './Purchase/scrapBit/scrapBitOutward';
import { addEditScrapBitOutward } from './Purchase/scrapBit/addEditScrapBitOutward';
import { scrapBitPrint } from './Purchase/scrapBit/scrapBitPrint';
import { fabricStockReport } from './Purchase/fabricStockReport/fabricStockReport';
import { purchaseCancel } from './Purchase/purchaseCancel/purchaseCancel';
import { poStatusBulkPending } from './Purchase/poStatusBulkPending/poStatusBulkPending';
import { sampleSwatchGrn } from './Purchase/grn/sampleSwatchGrn';
import { addEditSampleSwatchGrn } from './Purchase/grn/addEditSampleSwatchGrn';
import { nonOrderedDesignList } from './Purchase/invoice/nonOrderedDesignList';
import { sampleSwatchPendingReport } from './Purchase/POStatusReports/sampleSwatchPendingReport/sampleSwatchPendingReport';
import { bulkPendingReport } from './Purchase/POStatusReports/bulkPendingReport/bulkPendingReport';
import { salesOrderPlanMasterReport } from './master/salesOrderPlanMasterReport/salesOrderPlanMasterReport';
import { newPendingOrder } from './salesReports/newPendingOrder/newPendingOrder';
import { purchasePlan } from './Purchase/purchasePlan/purchasePlan';
import { purchasePlanReport } from './Purchase/purchasePlan/purchasePlanReport';
import { paymentVoucher } from './Sales/paymentVoucher/paymentVoucher';
import { paymentVoucherList } from './Sales/paymentVoucher/paymentVoucherList'
// import { partyPendingOrderVsStock } from './salesReports/partyPendingOrderVsStock/partyPendingOrderVsStock'
import { textileStockReport } from './report/textileStockReport/textileStockReport';
import { jobDcInward } from './Purchase/bitDc/jobDcInward';
import { jobDcInwardstock } from './Purchase/bitDc/jobDcInwardstock';
import { addEditJobInward} from './Purchase/bitDc/AddbitDcInward';
import { agentCommissionReport } from './salesReports/agentCommissionReport/agentCommissionReport';
import { AddEdittextileInvoiceComponent } from './Sales/salesInvoice/addEdittextileInvoice'; 
import { textileInvoiceComponent } from './Sales/salesInvoice/textileInvoice';
import { actualWorkreturnComponent } from './Purchase/workorder/actualWorkReturn';
import { workReturnInwardComponent } from './Purchase/workorder/workReturnInward';
import { AddMultiFabComponent } from './Purchase/workorder/AddMultiFabComponent'; 
import { MulticolorFab } from './Purchase/workorder/MulticolorFab';
import { jobWorkOrderComponent } from './Purchase/jobworkorder/jobworkOrder';
import { jobverifiedestimatewoComponent } from './Purchase/jobworkorder/jobverifiedEstimateWo';
import { AddEditjobEstiWorkOrder } from './Purchase/jobworkorder/addEditjobEstiWorkOrder';
import { approvedJobWorkOrder } from './Purchase//jobworkorder/approvedJobWorkOrder';
import { addEditJobWODc } from './Purchase/jobworkorder/addEditJobWODc';
import { fmjobDcApproval } from './Purchase/jobworkorder/fmjobDcApproval';
import { jobcuttingPlan } from './Purchase/jobworkorder/jobcuttingPlan';
import { jobProductionStore } from './Purchase/jobworkorder/jobProductionStore';
import { JobActualCuttingComponent } from './Purchase/jobworkorder/JobactualCutting';
import { AddEditJobActualCutting } from './Purchase/jobworkorder/addEditJobActualCutting';
import { jobwoDelivery } from './Purchase/jobworkorder/jobwoDelivery';
import { addEditJobWoDelivery } from './Purchase/jobworkorder/addEditJobWoDelivery';
import { jobwoDelRdApproval } from './Purchase/jobworkorder/jobwoDelRdApproval';
import { jobBalanceBitInward } from './Purchase/jobworkorder/jobBalanceBitInward';
import { jobwoDelFmApproval } from './Purchase/jobworkorder/jobwoDelFmApproval';
import { jobOcrPrint } from './Purchase/jobworkorder/jobOcrPrint';
import { jobRgrnComponent } from './Purchase/jobworkorder/jobRgrnComponent';
import { addEditJobRgrn } from './Purchase/jobworkorder/addEditJobRgrn'
import { dcBarcodePrint } from './Purchase/bitDc/dcBarcodePrint';
// import { AddagentDed } from './Sales/paymentVoucher/AddagentDed';
import { plainmaster } from './master/Plainmaster';
import { addplainmaster } from './master/addPlainmaster';
// import { AddagentDedList } from './Sales/paymentVoucher/AddagentDedList';
import { designMaster } from './master/designMaster/designMaster';
import { salesPlanadd } from './master/salesplanAdd/salesPlanadd';
import { bitmaster } from './master/bitmaster';
import { addbitmaster } from './master/addbitmaster';
import { widthmaster } from './master/widthmaster';
import { addwidthmaster } from './master/addwidthmaster';
import { qualitymaster } from './master/qualitymaster';
import { addqualitymaster } from './master/addqualitymaster';
import { rangeStock } from './master/rangeStock/rangeStock';
import { categorymaster } from './master/categorymaster';
import { addcategorymaster } from './master/addcategorymaster';
import {PurchaseStatus} from './Purchase/newReport/PurchaseStatusReport';
import {outwardPrint} from './Sales/agentOutward/outwardPrint';
import { specialDiscParties } from './Sales/specialDisCustomer/specialDisc';
import { settingsComponent } from './Sales/settingControl/settings';
import { plainSostatus } from './Sales/plainSo/plainSostatus';
// import { chqReturn } from './Sales/chequeReturn/chqreturn';
// import { salesretComponenet } from './Sales/saleReturn/salesret';
import { grnInward } from './Purchase/grn/grnInward';
import { jgrnInward } from './Purchase/jgrnStockReport/jgrnInward';
import { rgrnBarcodePrint } from './Purchase/jobworkorder/rgrnbarcodePrint';
import { jobReceived } from './Purchase/jgrnStockReport/jobDcreceived';
import { woreturnreport } from './Purchase/workorder/woReturnreport/woretreport';
import { woDcreport } from './Purchase/grnOutward/woDcreport';
import { fabRetreport } from './Purchase/grnOutward/fabRetreport';
import { jobDcoutward } from './Purchase/grnOutward/jobdcOutReport';
import { rndDcReport } from './Purchase/grnOutward/rndDcReport';
import { textileInvreport } from './Purchase/grnOutward/textileInvreport';
import { partyAllinvoice } from './salesReports/partyAllinvoice';
// import { AddEditAgent } from './master/Agent/addEditAgent';
import { addCourierInward } from './Sales/courier/addCourierInward';
import { courierInward } from './Sales/courier/courierInward';
import { addPayment } from './Sales/courier/addPayment';
import { pdcList } from './Sales/courier/pdcList';
import { SpecialInvoiceComponent } from './Sales/salesInvoice/specialInvoice';
import { TrimsInvoiceComponent } from './Sales/salesInvoice/trimsInvoice';
import { AddEditTrimsInvoiceComponent } from './Sales/salesInvoice/addEditTrimsInvoice';
import { AddEditSpecialInvoiceComponent } from './Sales/salesInvoice/addEditSpecialInvoice';
import { customerOutstandingReportComponent } from './report/OutstandingReport/customerOutstandingReport';
import { outstandingDatewiseReportComponent } from './report/OutstandingReport/outstandingDatewiseReport';
import { woRgrnreport } from './Purchase/woreports/woRgrnreport';
import { monthRgrnReport } from './Purchase/woreports/monthRgrnReport';
import { monthWoReport } from './Purchase/woreports//monthWoReport';
import { workOrderprocessReport } from './Purchase/woreports/workOrderprocess';
import { printWOpage } from './Purchase/workorder/printWopage';
// import { invdiffreport } from './Purchase/grnReport/invoice_diff';
import { customersoReport } from './report/SalesOrderReports/designSoReport/customersoReport';
import { orderVSst_status } from './report/SalesOrderReports/designSoReport/orderVSst_status';
import { styleMaster } from './master/styleMaster';
import { widthConsMaster } from './master/widthConsMaster';
import { addStyleMaster } from './master/addStyleMaster';
import { addWidthConsMaster } from './master/addWidthConsMaster';
import { plainSoReport } from './report/SalesOrderReports/designSoReport/plainSoReport';
import { counterdcReport } from './report/SalesOrderReports/designSoReport/counterdcReport';
import { plainorderVSst_status } from './report/SalesOrderReports/designSoReport/plainorderVSst_status';
import { plainorderReport } from './report/SalesOrderReports/designSoReport/plainorderReport';
import { addFactorydelPlan } from './Sales/factoryDelPlan/add_factorydel_plan';
import { factorydel_plan } from './Sales/factoryDelPlan/factorydel_plan';
import { salesPlanerAdd } from './master/salesPlanerAdd/addSalesPlan';
import { CustomerSalesPlanAdd } from './master/CustomerSalesPlanAdd/addCustomerSalesPlan.component';
import { addFactoryProdPlan } from './Sales/factoryProdPlan/addFactoryProdPlan';
import { factoryProdPlan } from './Sales/factoryProdPlan/factoryProdPlan';
import { yearPlanAdd } from './master/yearPlanAdd/addYearPlan';
import { ocrDc } from './Purchase/ocrDc/ocrDc';
import { ocrDcPrint } from './Purchase/ocrDc/ocrDcPrint';
import { FactoryDelVsProcess } from './Purchase/FactoryDelVsProcessReport/FactoryDelVsProcessReport';
import {jobocrDc} from './Purchase/jobworkorder/jobocr_dc';
import { stockNewtransfer } from './Purchase/sample/stockNewtransfer'
import { stockNewUpdate } from './Purchase/sample/stockNewUpdate';
import { productionMaster} from './master/productionMaster';
import { addProductionListMaster} from './master/addProductionListMaster';
import { cuttingStoreComponent } from './Purchase/cuttingStore/cuttingStore';
import { AddEditCuttingStore } from './Purchase/cuttingStore/addEditCuttingStore';
import { storeFusingComponent } from './Purchase/storeFusing/storeFusing';
import { AddEditStoreFusing } from './Purchase/storeFusing/addEditStoreFusing';
import { cuttingDcPrint } from './Purchase/cuttingStore/cuttingDcPrint';
import {sewingComponent} from './Purchase/storeToSewing/storeSewing';
import {AddEditSewing} from './Purchase/storeToSewing/addEditStoreSewing';
import { salesOrderCancel } from './Sales/salesOrderCancel/salesOrderCancel';
import { salesOrderCancelReport } from './Sales/salesOrderCancel/salesOrderCancelReport';
import { countCustomer } from './report/SalesOrderReports/designSoReport/countCustomer';
import { designWiseCounterEst } from './report/SalesOrderReports/designSoReport/designWiseCounterEst';
import { partyWiseCounterEst } from './report/SalesOrderReports/designSoReport/partyWiseCounterEst';
import { counterdcList } from './report/SalesOrderReports/designSoReport/counterdcList'
import { addcounterDC } from './report/SalesOrderReports/designSoReport/addcounterDC'
import { counterTransfer } from './report/SalesOrderReports/designSoReport/counterTransfer'
import { addcounterTransfer } from './report/SalesOrderReports/designSoReport/addcounterTransfer'
import { addPoplanComponent } from './Purchase/poplan/addpoplainplan';
import { plainpoEstimateComponent } from './Purchase/poplan/plainpoEstimate';
import { seasonPlanAgainstsoProessReport } from './master/YearlysalesPlanMasterReport/YearlysalesPlanMasterReport';
import { dSample } from './Purchase/sample/dSample';
import { AddEditDSample } from './Purchase/sample/AddEditDSample';
import { dStock } from './Purchase/sample/dStock';
import { AddEditDStock } from './Purchase/sample/AddEditDStock';
import { custDeliveryReport } from './master/customerDelivery/custDeliveryReport';
import { designSostatusReport } from './report/SalesOrderReports/designSoReport/designSostatusReport';
import { openOrderConvertion } from './Sales/salesOrder/openOrderConvertion';
import { addsetmaster } from './master/addsetmaster';
import { AddeditBagging } from './Purchase/sample/AddEditbagging';
import { AddeditExistSetBagging } from './Purchase/sample/AddEditExistSetbagging';
import { addBagmaster } from './master/bagMaster/addBagmaster';
import { bagMasterComponent } from './master/bagMaster/bagMaster';
import { addItemtype } from './master/addItemtype';
import { addWarehouse } from './master/addWarehouse';
import { addRackmaster } from './master/RackMaster/addRackmaster';
import { rackMasterComponent } from './master/RackMaster/RackMaster';
import { addopenStockset } from './master/addopenStockset';
import { addcolorGroup } from './master/addcolorGroup';
import { partyPendingOrdreport } from './report/SalesOrderReports/partyOrderReport/partyPendingOrdreport';
import { openingStockreport } from './salesReports/openingStockreport';
import { rackAllocation } from './master/RackAllocation/rackAllocation';
import { addRackallocation } from './master/RackAllocation/addRackallocation';
import { baggingStockreport } from './report/BaggingRackingReports/baggingStockreport';
import { rgrnBagpending } from './report/BaggingRackingReports/rgrnBagpending';
import { rackPending } from './report/BaggingRackingReports/rackPendingreport';
import { coreSwatchReport } from './swatch/coreSwatchReport/coreSwatchReport';
import { swatchEvalutionReport } from './swatch/swatchEvalutionReport/swatchEvalutionReport';
import { cdcEstimation } from './phase1/CdcEstimation/cdcEstimation';
import { partywiseAssignStock } from './phase1/WhWorkOrder/AssignStocks/partywiseAssignStock';
import { addWhWorkOrder } from './phase1/WhWorkOrder/addWhWorkOrder';
import { whWorkOrder } from './phase1/WhWorkOrder/whWorkOrder';
import { whWorkOrderAssign } from './phase1/WhWorkOrderAssign/whWorkOrderAssign';
import { addWhWorkOrderAssign } from './phase1/WhWorkOrderAssign/addWhWorkOrderAssign';
import { addCdcEstimationNew } from './phase1/CdcEstimation/addCdcEstimationNew';
import { draftedRackreport } from './report/BaggingRackingReports/draftedRackreport';

export const APP_COMPONENTS: any[] = [
    charts,
    salesPlanMasterReport,
    salesPlanEntry,
    // poBulkPending,
    lrGrnVerification,
    MatchDCComponent,
    AddEditMatchDC,
    WoReturnComponent,
    verifyEstimate,
    estimateBundle,
    DamageInvoiceComponent,
    AddEditDamageInvoiceComponent,
    oliveInvoiceComponent,
    AddEditOliveInvoiceComponent,
    jobInvoiceComponent,
    AddEditJobInvoiceComponent,
    seasonWiseAnnualReport,
    monthSalesOrderReport,
    invoiceReturnReport,
    pcswiseAnnualReport,
    valuewiseAnnualReport,
    agentStockReport,
    agentInwardComponent,
    addEditAgentInwardComponent,
    workOrderInward,
    addEditWorkOrderInward,
    verifiedEstimate,
    // OrderVsTargetReport,
    // mismatchList,
    overAllStockReport,
    partyNewJoineeReport, 
    partyInactiveReport,
    fabricStockTransfer,
    // rdAgainstReport,
    newDesignStockReport,
    designSoStockReport,
    designWiseOrderPlacing,
    designVsOrderReport,
    swatchWoReport,
    coreStatusReport,
    SalesInvoiceReportComponent,
    coreDesignStockReport,
    addCoreGang,
    coreGangMaster,
    designDeliveryReport,
    partyOrderReport,
    styleSoReport,
    designSoReport,
    // rackStockReport,
    // rackTransList,
    // rackTrans,
    // rackList,
    // rackStock,
    printFairSample,
    coreStockReport,
    printCutting,
    verifySalesOrder,
    // dgrnComponent,
    // addEditDgrn,
    sampleDcReport,
    woVsStockReport,
    sampleInward,
    continuosNumber,
    sampleRemainReport,
    purchaseOrderStatusReport,
    partysalesvalueReport,
    partysalespcsReport,
    mrpSalesReport,
    salesReport,
    monthSalesReport,
    fabricBendingReport,
    stocktransfer,
    stockUpdate,
    sampleFair,
    invoiceVsGrn,
    PartySeasonalReport,
    DesignDataComponent,
    addEditRgrn,
    CoreprocessReport,
    woFabricDeliveryPending,
    RgrnComponent,
    StockReport,
    factoryStockreport,
    SalesInvoiceAgent,
    DesignTile,
    AddEditSalesPlanReport,
    InactivePartyReport,
    DesignWiseSalesOrderReport,
    woprocessreport,
    agewiseworeport,
    // stocktransferreport,
    cuttingdetailsreport,
    monthwisewo,
    NonOrderedDesignReport,
    NewPartyReport,
    DesignWiseSOReport,
    NonOrderedParty,
    AgentSeasonalReport,
    SalesPlanReport,
    AgentYearlyReport,
    PlandetailsMasterComponent,
    SeasonMasterComponent,
    AddEditSeasonComponent,
    PhotoDialog,
    PartySalesOrderReport,
    SeasonTargetReport,
    PartySalesQtyReport,
    salesReturnReport,
    Table2,
    Table3,
    AgGridComponent,
    workorderprint,
    fairStock,
    // OrderAgainstInvoice,
    SalesOrderReport,
    SalesOrderDetailsReport,
    SalesInvoiceReport,
    SalesInvoiceDetailsReport,
    MenuMapping,
    PurchaseInvoiceComponent,
    AddEditInvoice,
    PurchaseOrderComponent,
    AddEditPurchaseOrder,
    POCancelComponent,
    AddEditPOCancel,
    LorryInvoice,
    // workActualDgrn,
    AddEditLorryInvoice,
    PurchaseOrderReport,
    PurchaseInvoiceReport,
    LRInvoiceReport,
    OrderVsInvoiceReport,
    GrnListComponent,
    AddEditGrn,
    AddEditJGRN,
    JGRNComponent,
    LorryUpdate,
    AddEditLorryUpdate,
    // LRVsGRNReport,
    GrnReport,
    PurchaseReturnComponent,
    AddEditPurchaseReturn,
    PurchaseStockReport,
    DCComponent,
    AddEditDC,
    fabricPrint,
    SampleComponent,
    AddEditSample,
    AddEditcreateSample,
    WorkOrderComponent,
    sampleFairReport,
    //woprint,
    AddEditWorkOrder,
    ActualCuttingComponent,
    AddEditActualCutting,
    SampleReport,
    ClothDCReport,
    NewPurchaseReport,
    AgentWiseReport,
    SampleGrnStockReport,
    CostingSample,
    CostingList,
    WOReport,
    SwatchComponent,
    SwatchPendingReport,
    AddEditSwatch,
    SwatchReport,
    CuttingReport,
    CostingSampleReport,
    WOVsCuttingReport,
    UserComponent,
    AddEditUser,
    DesignStock,
    AddEditDesignStock,
    DesignList,
    AddEditDesignList,
    SalesOrderComponent,
    brandStockComponent, 
    AddEditSalesOrder,
    addEditBrandStock,
    SalesInvoiceReturn,
    salesReturnBundle,
    AddEditSalesReturn,
    addEditSalesReturnBundle,
    addEditCommission,
    commissionMaster,
    addEditAgentpayment,
    agentPaymentEntry,
    // SalesReplacement,
    // AddEditSalesReplacement,
    PartyComponent,
    AddEditParty,
    ViewReprintBarcodeComponent,
    SalesInvoiceComponent,
    AddEditSalesInvoiceComponent,
    SampleInwardComponent,
    InwardEntryComponent,
    DcComponent,
    DcEntryComponent,
    DcReport,
    PrintData,
    CoreDesignReport,
    PrintWorkOrder,
    PrintLRData,
    PartyInvoiceReport,
    GrnColorReport,
    SampleStockReport,
    agentSalesReport,
    POVsGRNReport,
    // JgrnStockReport,
    SamplePrint,
    // OFSReportComponent,
    LRSReportComponent,
    BundleReportComponent,
    deliverypendingReport,
    workActualRgrn,
    agentOutwardComponent,
    addEditAgentOutwardComponent,
    seasonWiseValueAnnualReport,
    salesOrderReport,
    AddEditEstiWorkOrder,    
    verifiedestimatewoComponent,
    mrpSalesOrderReport,
    POSampleReport,
    PoSwatchReport,
    SampleCancelReport,
    SampleReturn,
    addEditSampRet,
    mrpSampleReport,
    estimateWoReport,
    approvedWorkOrder,
    approvedWoReport,
    SampleReturnInward,
    estimateStockReport,
    matchingDesignList,
    matchDesignList,
    sampleToBitConvertGrn,
    addEditsampleToBitConvertGrn,
    // barcodeHistory,
    shirtStockReport,
    corePendingOrder,
    convertShirtTypes,
    shirtTypeupdate,
    woreturnInwardReport,
    researchToWarehouseTextileDc,
    researchDcList,
    researchDcReport,
    cuttingPlan,
    cuttingPlanPrint,
    ff_cp_report,
    designUpload,
    orderFormDesignPhoto,
    designPhotoList,
    bitFabricStock,
    addEditBitStock,
    bitStockReport,
    bitCurrentStock,
    factoryReport,
    fmDcApproval,
    woDelivery,
    addEditWoDelivery,
    woDelFmApproval,
    woDelRdApproval,
    balanceBitInward,
    ocrPrint,
    // productionStore,
    // fusing,
    // frontAndRecutting,
    // stitching,
    // kajaAndButton,
    // fusingPrint,
    // frPrint,
    // stitchingPrint,
    // kbPrint,
    bitDc,
    addEditBitDc,
    bitDcPrint,
    openOrderReport,
    scrapBitStock,
    addEditScrapBitOutward,
    scrapBitOutward,
    scrapBitPrint,
    fabricStockReport,
    purchaseCancel,
    poStatusBulkPending,
    sampleSwatchGrn,
    addEditSampleSwatchGrn,
    nonOrderedDesignList,
    sampleSwatchPendingReport,
    bulkPendingReport,
    salesOrderPlanMasterReport,
    newPendingOrder,
    purchasePlan,
    purchasePlanReport,
    paymentVoucher,
    paymentVoucherList,
    // partyPendingOrderVsStock,
    textileStockReport,
    jobDcInward,
    jobDcInwardstock,
    addEditJobInward,
    agentCommissionReport,
    AddEdittextileInvoiceComponent,
    textileInvoiceComponent,
    actualWorkreturnComponent,
    workReturnInwardComponent,
    AddMultiFabComponent,
    MulticolorFab,
    jobWorkOrderComponent,
jobverifiedestimatewoComponent,
AddEditjobEstiWorkOrder,
approvedJobWorkOrder,
addEditJobWODc,
fmjobDcApproval,
jobcuttingPlan,
jobProductionStore,
JobActualCuttingComponent,
AddEditJobActualCutting,
jobwoDelivery,
addEditJobWoDelivery,
jobwoDelRdApproval,
jobBalanceBitInward,
jobwoDelFmApproval,
jobOcrPrint,
jobRgrnComponent,
addEditJobRgrn,
 dcBarcodePrint,
//  AddagentDed,
 plainmaster,
 addplainmaster,
//  AddagentDedList,
designMaster,
salesPlanadd,
bitmaster,
addbitmaster,
widthmaster,
qualitymaster,
addqualitymaster,
addwidthmaster,
rangeStock,
categorymaster,
addcategorymaster,
PurchaseStatus,
outwardPrint,
specialDiscParties,
settingsComponent,
plainSostatus,
// chqReturn,
// salesretComponenet,
grnInward,
jgrnInward,
rgrnBarcodePrint,
jobReceived,
woreturnreport,
woDcreport,
fabRetreport,
jobDcoutward,
rndDcReport,
textileInvreport,
partyAllinvoice,
// AddEditAgent,
addCourierInward,
courierInward,
addPayment,
pdcList,
SpecialInvoiceComponent,
TrimsInvoiceComponent,
AddEditTrimsInvoiceComponent,
AddEditSpecialInvoiceComponent,
customerOutstandingReportComponent,
outstandingDatewiseReportComponent,
woRgrnreport,
monthRgrnReport,
monthWoReport,
workOrderprocessReport,
printWOpage,
// invdiffreport,
customersoReport,
orderVSst_status,
styleMaster,
widthConsMaster,
addStyleMaster,
addWidthConsMaster,
plainSoReport,
counterdcReport,
plainorderVSst_status,
plainorderReport,
addFactorydelPlan,
factorydel_plan,
salesPlanerAdd,
CustomerSalesPlanAdd,
addFactoryProdPlan,
factoryProdPlan,
yearPlanAdd,
ocrDc,
ocrDcPrint,
FactoryDelVsProcess,
jobocrDc,
stockNewtransfer,
stockNewUpdate,
productionMaster,
addProductionListMaster,
cuttingStoreComponent,
 AddEditCuttingStore, 
storeFusingComponent,
AddEditStoreFusing,
cuttingDcPrint,
sewingComponent,
AddEditSewing,
salesOrderCancel,
salesOrderCancelReport,
countCustomer,
designWiseCounterEst,
partyWiseCounterEst,
counterdcList,
addcounterDC,
counterTransfer,
addcounterTransfer,
addPoplanComponent,
plainpoEstimateComponent,
seasonPlanAgainstsoProessReport,
dSample,
AddEditDSample,
dStock,
AddEditDStock,
custDeliveryReport,
designSostatusReport,
openOrderConvertion,
addsetmaster,
AddeditBagging,
AddeditExistSetBagging,
addBagmaster,
bagMasterComponent,
addItemtype,
addWarehouse,
addRackmaster,
rackMasterComponent,
addopenStockset,
addcolorGroup,
partyPendingOrdreport,
openingStockreport,
rackAllocation,
addRackallocation,
baggingStockreport,
rgrnBagpending,
whWorkOrder,
addWhWorkOrder,
partywiseAssignStock,
cdcEstimation,
rackPending,
whWorkOrderAssign,
addWhWorkOrderAssign,
addCdcEstimationNew,
coreSwatchReport,
swatchEvalutionReport,
draftedRackreport
];
export * from './Purchase/workorder/woprint';
export * from './Purchase/woreports/charts';
// export * from './Purchase/grn/mismatchList';
export * from './Sales/salesInvoice/verifyEstimate';
export * from './Sales/salesInvoice/estimateBundle';
export * from './Sales/salesInvoice/verifiedEstimate';
// export * from './Purchase/poBulkPending/poBulkPending';
export * from './Purchase/workorder/workOrderInward/addEditWorkOrderInward';
export * from './Purchase/workorder/workOrderInward/workOrderInward';
export * from './salesReports/overAllStockReport';
export * from './salesReports/PartyNewJoineeReport';
export * from './salesReports/partyInactiveReport';
export * from './salesReports/pcswiseAnnualReport';
export * from './salesReports/valuewiseAnnualReport';
export * from './salesReports/agentStockReport';
export * from './Purchase/sample/fabricStockTransfer';
// export * from './Purchase/woreports/rdAgainstReport';
export * from './report/SalesOrderReports/partyOrderReport/partyOrderReport';
export * from './salesReports/coreDesignStockReport';
export * from './salesReports/coreDesignStockReport';
export * from './Purchase/coreGangMaster/addCoreGang';
export * from './Purchase/coreGangMaster/coreGangMaster';
export * from './report/designSoStockReport/designSoStockReport';
export * from './Purchase/purchaseOrderReport/swatchWoReport';
export * from './salesReports/sales-invoice-report/SalesInvoiceReportComponent'
export * from './report/SalesOrderReports/coreGangReport/coreStatusReport';
export * from './salesReports/designVsOrderReport';
export * from './salesReports/designDeliveryReport';
export * from './report/SalesOrderReports/designSoReport/styleSoReport';
export * from './report/SalesOrderReports/designSoReport/designSoReport';
// export * from './Purchase/woreports/rackStockReport';
// export * from './Purchase/RackTransfer/rackTransList';
// export * from './Purchase/RackTransfer/rackTrans';
// export * from './Purchase/RackTransfer/rackStock';
// export * from './Purchase/RackTransfer/rackList';
export * from './Purchase/coredesignReport/coreStockReport';
export * from './Purchase/sample/printFairSample';
export * from './Purchase/actualcutting/printCutting';
export * from './Sales/salesOrder/verifySalesOrder';
// export * from './Purchase/woreports/workActualDgrn';
// export * from './Purchase/dgrn/dgrnComponent';
// export * from './Purchase/dgrn/addEditDgrn';
export * from './Purchase/purchaseOrderReport/sampleDcReport';
export * from './Purchase/purchaseOrderReport/sampleRemainReport';
export * from './Purchase/purchaseOrderReport/fabricBendingReport';
export * from './Purchase/purchaseOrderReport/poStatusReport';
export * from './salesReports/salesReturnReport';
export * from './Purchase/woreports/factoryStockreport';
export * from './Purchase/woreports/factoryStockreport';
export * from './salesReports/partysalesvalueReport';
export * from './salesReports/partysalespcsReport';
export * from './salesReports/mrpSalesReport';
export * from './salesReports/agentSalesReport';
export * from './salesReports/salesReport';
export * from './salesReports/monthSalesReport';
// export * from './Purchase/woreports/stocktransferreport';
export * from './Purchase/woreports/agewiseworeport';
export * from './Purchase/woreports/monthwisewo';
export * from './Purchase/woreports/cuttingdetailsreport';
export * from './Purchase/woreports/CoreprocessReport';
export * from './Purchase/woreports/woFabricDeliveryPending';
export * from './Purchase/woreports/woprocessreport';
export * from './Purchase/rgrn/RgrnComponent';
export * from './Purchase/rgrn/addEditRgrn'
export * from './Purchase/sample/fairStock';
export * from './Purchase/sample/stocktransfer';
export * from './Purchase/sample/stockUpdate';
export * from './Purchase/sample/AddEditcreateSample';
export * from './Purchase/sampleReport/sampleFairReport';
export * from './Purchase/sample/sampleInward';
export * from './report/SalesOrderReports/salesOrderReport/SoReport.component';
// export * from './report/comparison/ordervstarget/orderTarget.component';
export * from './master/DesignData/DesignData';
export * from './report/DeliveryReport/DeliveryReport';
export * from './report/StockReport/StockReport';
export * from './report/NonOrderedDesignReport/NonOrderedDesignReport';
export * from './report/NonOrderedParty/NonOrderedParty';
export * from './report/DesignWiseSOReport/DesignWiseSOReport';
export * from './report/salesplanreport/addEditSalesplan.component';
export * from './report/salesplanreport/salesplanreport.component';
export * from './master/Plandetails/plandetails.component';
export * from './master/Season/season.component';
export * from './master/Season/addEditSeason.component';
export * from './report/AgentSeasonalReport/AgentSeasonalReport';
export * from './master/User/user';
export * from './master/User/addEditUser';
export * from './Purchase/sample/sampleFair';
export * from './report/DesignPhotos/photos.component';
export * from './report/AgentYearlyReport/AgentYearlyReport';
export * from './report/PartySalesOrderReport/PartySalesOrderReport';
export * from './report/SeasonTargetReport/seasontarget.component';
export * from './report/DcReport/DcReport.component';
export * from './report/PartyOrderQty/PartyOrderQtyReport';
export * from './report/NewPartyReport/NewPartyReport';
export * from './report/InactivePartyReport/InactivePartyReport';
export * from './report/PartySeasonalReport/PartySeasonalReport';
// export * from './report/comparison/OrderAgainstInvoiceReport/OrderAgainstInvoiceReport.component';
export * from './report/OrderwiseReport/SalesOrder';
export * from './report/OrderwiseReport/SalesOrderdetails';
export * from './report/salesReport/SalesInvoice';
export * from './report/salesReport/SalesInvoicedetails';
export * from './master/menuMapping/menuMapping.component';
export * from './Purchase/invoice/invoice.component';
export * from './Purchase/invoice/addEditInvoice.component';
export * from './Purchase/purchaseOrder/purchaseOrder';
export * from './Purchase/purchaseOrder/addEditPurchaseOrder';
export * from './Purchase/poCancel/poCancelList';
export * from './Purchase/poCancel/addEditPOCancel';
export * from './Purchase/lorryDetails/lorry';
export * from './Purchase/lorryDetails/addEditlorry';
export * from './Purchase/purchaseOrderReport/poReport';
export * from './Purchase/purchaseOrderReport/invoiceVsGrn';
export * from './Purchase/LRinvoiceReport/invoicereport.component';
export * from './Purchase/lorryReport/lorryReport';
export * from './Purchase/ordervsinvoice/OrderVsInvoice';
export * from './Purchase/grn/addEditGrn';
export * from './Purchase/grn/grn';
export * from './Purchase/jgrn/AddEditJGRN';
export * from './Purchase/jgrn/JGRN';
// export * from './Purchase/lorryUpdate/lorryUpdate';
export * from './Purchase/lorryUpdate/addEditLorryUpdate';
// export * from './Purchase/LRagainstGRN/LRvsGRN';
export * from './Purchase/grnReport/grnReport';
export * from './Purchase/purchaseReturn/purchaseReturn';
export * from './Purchase/purchaseReturn/addEditPurchaseReturn';
export * from './Purchase/purchaseStockReport/pstockReport';
export * from './Purchase/Dccutting/dcCutting';
export * from './Purchase/Dccutting/addEditDc';
export * from './Purchase/fabricPrint/fabricPrint';
export * from './Purchase/sample/sample';
export * from './Purchase/sample/addEditSample';
export * from './Purchase/workorder/workOrder';
export * from './Purchase/workorder/addEditWorkOrder';
export * from './Purchase/actualcutting/actualCutting';
export * from './Purchase/actualcutting/addEditActualCutting';
export * from './Purchase/sampleReport/sampleReport';
export * from './Purchase/dcReport/clothdcReport';
export * from './Purchase/newReport/newPurchaseReport';
export * from './Purchase/agentWiseReport/agentWiseReport';
export * from './Purchase/sampleGrnStockReport/sampleGrnStockReport';
export * from './Purchase/costingSample/costingSample';
export * from './Purchase/costingSample/costingList';
export * from './Purchase/workOrderReport/woReport';
export * from './Purchase/swatch/swatch';
export * from './Purchase/swatch/swatchDetails';
export * from './report/designWiseOrderPlacing/designWiseOrderPlacing';
export * from './Purchase/swatchReport/swatchReport';
export * from './Purchase/swatchPendingReport/swatchPendingReport';
export * from './Purchase/cuttingReport/cuttingReport';
export * from './Purchase/costReport/costSampleReport';
export * from './Purchase/WOVsCutting/WOVsCutting';
export * from './master/DesignStock/designStock';
export * from './master/DesignStock/addEditdesignStock';
export * from './master/DesignList/designList';
export * from './master/DesignList/addEditdesignList';
export * from './Sales/salesOrder/salesOrder';
export * from './Sales/salesOrder/addEditSalesOrder';
export * from './Sales/brandStockInward/addEditBrandStock';
export * from './Sales/brandStockInward/brandStock';
export * from './Sales/salesReturn/salesReturn';
export * from './Sales/salesReturn/salesReturnBundle';
export * from './Sales/salesReturn/addEditSalesReturn';
export * from './Sales/salesReturn/addEditSalesReturnBundle';
export * from './Sales/commissionMaster/addEditCommission';
export * from './Sales/commissionMaster/commissionMaster';
export * from './Sales/agentPayment/addEditAgentpayment';
export * from './Sales/agentPayment/agentPaymentEntry';
// export * from './Sales/salesReplacement/salesReplacement';
// export * from './Sales/salesReplacement/addEditSalesReplacement';
export * from './master/party/party';
export * from './master/party/addEditParty';
export * from './master/ViewReprintBarcode/viewReprintBarcode';
export * from './Sales/salesInvoice/salesInvoice';
export * from './Sales/salesInvoice/addEditInvoice';
export * from './Sales/Inward/inwardList';
export * from './Sales/Inward/addEditInward';
export * from './Sales/Dc/dcList';
export * from './Sales/Dc/addEditDc';
export * from './master/print/print';
export * from './Purchase/coredesignReport/coreDesignReport';
export * from './Purchase/workorder/printWO';
export * from './Purchase/lorryDetails/print';
export * from './Purchase/partyInvoiceReport/partyinvoicereport.component';
export * from './Purchase/grncolorReport/grncolorreport.component';
export * from './Purchase/sampleStockReport/samplestockreport.component';
export * from './Purchase/POagainstGRN/POvsGRN';
// export * from './Purchase/jgrnStockReport/jgrnStockReport';
export * from './Purchase/sample/samplePrint';
// export * from './reportlist/order-form-stock/ofs.component';
export * from './reportlist/lr-stock/lrs.component';
export * from './salesReports/deliverypendingReport/deliverypending';
export * from './Purchase/workOrderReport/woVsStockReport';
export * from './Purchase/woreports/workActualRgrn';
export * from './Sales/agentOutward/agentOutward';
export * from './Sales/agentOutward/addEditAgentOutward';
export * from './Sales/agentInward/agentInward';
export * from './Sales/agentInward/addEditAgentInward';
export * from './salesReports/invoiceReturnReport';
export * from './salesReports/monthSalesOrderReport';
export * from './salesReports/seasonWiseAnnualReport';
export * from './salesReports/seasonWiseValueAnnualReport';
export * from './Sales/damageInvoice/damageInvoice';
export * from './Sales/damageInvoice/addEditDamageInvoice';
export * from './Sales/oliveInvoice/oliveInvoice';
export * from './Sales/oliveInvoice/addEditOliveInvoice';
export * from './Sales/jobInvoice/jobInvoice';
export * from './Sales/jobInvoice/addEditJobInvoice';
export * from './Purchase/workorder/woReturn';
export * from './report/SalesOrderReports/salesOrderReport/salesOrderReport';
export * from './Purchase/workorder/addEditEstiWorkOrder';
export * from './Purchase/workorder/verifiedEstimateWo';
export * from './Purchase/Dccutting/matchdcCutting';
export * from './Purchase/Dccutting/addEditMatchDc';
export * from './report/continuosNumber/continuosNumber';
export * from  './Purchase/lrGrnVerification/lrGrnVerification';
export * from './master/salesPlanMasterReport/salesPlanMasterReport';
export * from './report/SalesOrderReports/MrpSOReport/mrpSalesOrderReport';
export * from './Purchase/POStatusReports/poSampleReport/poSampleReport';
export * from './Purchase/POStatusReports/poSwatchReport/poSwatchReport';
export * from '../components/Purchase/sampleReport/sampleCancelReport';
export * from '../components/Purchase/sample/sampleReturn';
export * from '../components/Purchase/sample/addEditSampRet';
export * from './Purchase/sampleReport/mrpSampleReport';
export * from './Purchase/woreports/estimateWoReports';
export * from './Purchase/workorder/approvedWorkOrder';
export * from './Purchase/woreports/approvedWoReport';
export * from './Purchase/sample/sampleReturnInward';
export * from './master/salesPlanMasterReport/salesPlanEntry';
export * from './salesReports/sales-invoice-report/estimateStockReport';
export * from './Purchase/matchingDesignList/matchingDesignList';
export * from './Purchase/matchingDesignList/matchDesignList';
export * from './Purchase/sampleToBitConvertGrn/sampleToBitConvertGrn';
export * from './Purchase/sampleToBitConvertGrn/addEditsampleToBitConvertGrn';
// export * from './report/barcodeHistory/barcodeHistory';
export * from './report/shirtStockReport/shirtStockReport';
export * from './salesReports/corePendingOrder/corePendingOrder';
export * from './master/convertShirtTypes/convertShirtTypes';
export * from './master/convertShirtTypes/shirtTypeupdate';
export * from './Purchase/woreports/woreturnInwardReport/woreturnInwardReport';
export * from './Purchase/researchToWarehouseTextileDc/researchToWarehouseTextileDc';
export * from './Purchase/researchToWarehouseTextileDc/researchDcList';
export * from './Purchase/sampleReport/researchDcReport';
export * from './Purchase/workorder/cuttingPlan';
export * from './Purchase/workorder/cuttingPlanPrint';
export * from './Purchase/woreports/ff_cp_report';
export * from './master/designUpload/designUpload';
export * from './salesReports/orderFormDesignPhoto/orderFormDesignPhoto';
export * from './master/designPhotoList/designPhotoList';
export * from './Purchase/bitStock/addEditBitStock';
export * from './Purchase/bitStock/bitFabricStock';
export * from './Purchase/bitStockReport/bitStockReport';
export * from './Purchase/bitStockReport/bitCurrentStock';
export * from './Purchase/woreports/factoryReport/factoryReport';
export * from './Purchase/workorder/fmDcApproval';
export * from './Purchase/woDelivery/woDelivery';
export * from './Purchase/woDelivery/addEditWoDelivery';
export * from './Purchase/workorder/woDelFmApproval/woDelFmApproval';
export * from './Purchase/workorder/woDelRdApproval/woDelRdApproval';
export * from './Purchase/workorder/balanceBitInward/balanceBitInward';
export * from './Purchase/workorder/woDelFmApproval/ocrPrint';
// export * from './Purchase/workorder/productionStore/productionStore';
// export * from './Purchase/workorder/factory/fusing/fusing';
// export * from './Purchase/workorder/factory/frontAndRecutting/frontAndRecutting';
// export * from './Purchase/workorder/factory/stitching/stitching';
// export * from './Purchase/workorder/factory/kajaAndButton/kajaAndButton';
// export * from './Purchase/workorder/productionStore/fusingPrint/fusingPrint';
// export * from './Purchase/workorder/productionStore/frPrint/frPrint';
// export * from './Purchase/workorder/productionStore/stitchingPrint/stitchingPrint';
// export * from './Purchase/workorder/productionStore/kbPrint/kbPrint';
export * from './Purchase/bitDc/bitDc';
export * from './Purchase/bitDc/addEditBitDc';
export * from './Purchase/bitDc/bitDcPrint';
export * from './salesReports/openOrderReport/openOrderReport';
export * from './Purchase/scrapBit/scrapBitStock';
export * from './Purchase/scrapBit/scrapBitOutward';
export * from './Purchase/scrapBit/addEditScrapBitOutward';
export * from './Purchase/scrapBit/scrapBitPrint';
export * from './Purchase/fabricStockReport/fabricStockReport';
export * from './Purchase/purchaseCancel/purchaseCancel';
export * from './Purchase/poStatusBulkPending/poStatusBulkPending';
export * from './Purchase/grn/sampleSwatchGrn';
export * from './Purchase/grn/addEditSampleSwatchGrn';
export * from './Purchase/invoice/nonOrderedDesignList';
export * from './Purchase/POStatusReports/sampleSwatchPendingReport/sampleSwatchPendingReport';
export * from './Purchase/POStatusReports/bulkPendingReport/bulkPendingReport';
export * from './master/salesOrderPlanMasterReport/salesOrderPlanMasterReport';
export * from './salesReports/newPendingOrder/newPendingOrder';
export * from './Purchase/purchasePlan/purchasePlan';
export * from './Purchase/purchasePlan/purchasePlanReport';
export * from './Sales/paymentVoucher/paymentVoucher';
export * from './Sales/paymentVoucher/paymentVoucherList';
// export * from './salesReports/partyPendingOrderVsStock/partyPendingOrderVsStock';
export * from './report/textileStockReport/textileStockReport';
export * from './Purchase/bitDc/jobDcInward';
export * from './Purchase/bitDc/jobDcInwardstock';
export * from './Purchase/bitDc/AddbitDcInward';
export * from './salesReports/agentCommissionReport/agentCommissionReport';
export * from './Sales/salesInvoice/textileInvoice';
export * from './Sales/salesInvoice/addEdittextileInvoice';
export * from './Purchase/workorder/actualWorkReturn';
export * from './Purchase/workorder/workReturnInward';
export * from './Purchase/workorder/MulticolorFab';
export * from './Purchase/workorder/AddMultiFabComponent';
export * from './Purchase/jobworkorder/approvedJobWorkOrder';
export * from './Purchase/jobworkorder/fmjobDcApproval';
export * from './Purchase/jobworkorder/jobcuttingPlan';
export * from './Purchase/jobworkorder/jobProductionStore';
export * from './Purchase/jobworkorder/jobwoDelivery';
export * from './Purchase/jobworkorder/addEditJobWoDelivery';
export * from './Purchase/jobworkorder/jobwoDelRdApproval';
export * from './Purchase/jobworkorder/jobBalanceBitInward';
export * from './Purchase/jobworkorder/jobwoDelFmApproval';
export * from './Purchase/jobworkorder/jobOcrPrint';
export * from './Purchase/jobworkorder/jobRgrnComponent';
export * from './Purchase/jobworkorder/addEditJobRgrn'
export * from './Purchase/bitDc/dcBarcodePrint';
// export * from './Sales/paymentVoucher/AddagentDed';
export * from './master/Plainmaster';
export * from './master/addPlainmaster';
// export * from './Sales/paymentVoucher/AddagentDedList';
export * from './master/designMaster/designMaster';
export * from './master/salesplanAdd/salesPlanadd';
export * from './master/bitmaster';
export * from './master/addbitmaster';
export * from './master/widthmaster';
export * from './master/qualitymaster';
export * from './master/addqualitymaster';
export * from './master/addwidthmaster';
export * from './master/rangeStock/rangeStock'
export * from './master/categorymaster';
export * from './master/addcategorymaster';
export * from './Purchase/newReport/PurchaseStatusReport';
export * from './Sales/agentOutward/outwardPrint';
export * from './Sales/specialDisCustomer/specialDisc';
export * from './Sales/settingControl/settings';
export * from './Sales/plainSo/plainSostatus';
// export * from './Sales/chequeReturn/chqreturn';
// export * from './Sales/saleReturn/salesret';
export * from './Purchase/grn/grnInward';
export * from './Purchase/jgrnStockReport/jgrnInward';
export * from './Purchase/jobworkorder/rgrnbarcodePrint';
export * from './Purchase/jgrnStockReport/jobDcreceived';
export * from './Purchase/workorder/woReturnreport/woretreport';
export * from './Purchase/grnOutward/woDcreport';
export * from './Purchase/grnOutward/fabRetreport';
export * from './Purchase/grnOutward/jobdcOutReport';
export * from './Purchase/grnOutward/rndDcReport';
export * from './Purchase/grnOutward/textileInvreport';
export * from './salesReports/partyAllinvoice';
// export * from './master/Agent/addEditAgent';
export * from './Sales/courier/addCourierInward';
export * from './Sales/courier/courierInward';
export * from './Sales/courier/addPayment';
export * from './Sales/courier/pdcList';
export * from './Sales/salesInvoice/specialInvoice';
export * from './Sales/salesInvoice/trimsInvoice';
export * from './Sales/salesInvoice/addEditTrimsInvoice';
export * from './Sales/salesInvoice/addEditSpecialInvoice';
export * from './report/OutstandingReport/customerOutstandingReport';
export * from './report/OutstandingReport/outstandingDatewiseReport';
export * from './Purchase/woreports/woRgrnreport';
export * from './Purchase/woreports/monthRgrnReport';
export * from './Purchase/woreports/monthWoReport';
export * from './Purchase/woreports/workOrderprocess';
export * from './Purchase/workorder/printWopage';
// export * from './Purchase/grnReport/invoice_diff';
export * from './report/SalesOrderReports/designSoReport/customersoReport';
export * from './report/SalesOrderReports/designSoReport/orderVSst_status';
export * from './master/styleMaster';
export * from './master/widthConsMaster';
export * from './master/addStyleMaster';
export * from './master/addWidthConsMaster';
export * from './report/SalesOrderReports/designSoReport/plainSoReport';
export * from './report/SalesOrderReports/designSoReport/counterdcReport';
export * from './report/SalesOrderReports/designSoReport/plainorderVSst_status';
export * from './report/SalesOrderReports/designSoReport/plainorderReport';
export * from './Sales/factoryDelPlan/add_factorydel_plan';
export * from './Sales/factoryDelPlan/factorydel_plan';
export * from './master/salesPlanerAdd/addSalesPlan';
export * from './master/CustomerSalesPlanAdd/addCustomerSalesPlan.component';
export * from './Sales/factoryProdPlan/addFactoryProdPlan';
export * from './Sales/factoryProdPlan/factoryProdPlan';
export * from './master/yearPlanAdd/addYearPlan';
export * from './Purchase/ocrDc/ocrDc';
export * from './Purchase/ocrDc/ocrDcPrint';
export * from './Purchase/FactoryDelVsProcessReport/FactoryDelVsProcessReport';
export * from  './Purchase/jobworkorder/jobocr_dc';
export * from './Purchase/sample/stockNewtransfer';
export * from './Purchase/sample/stockNewUpdate';
export * from './master/productionMaster';
export * from './master/addProductionListMaster';
export * from './Purchase/cuttingStore/cuttingStore';
export * from './Purchase/cuttingStore/addEditCuttingStore';
export * from './Purchase/storeFusing/storeFusing';
export * from './Purchase/storeFusing/addEditStoreFusing';
export * from './Purchase/cuttingStore/cuttingDcPrint';
export * from './Purchase/storeToSewing/storeSewing';
export * from './Purchase/storeToSewing/addEditStoreSewing';
export * from './Sales/salesOrderCancel/salesOrderCancel';
export * from './Sales/salesOrderCancel/salesOrderCancelReport';
export * from './report/SalesOrderReports/designSoReport/countCustomer';
export * from './report/SalesOrderReports/designSoReport/designWiseCounterEst';
export * from './report/SalesOrderReports/designSoReport/partyWiseCounterEst';
export * from './report/SalesOrderReports/designSoReport/counterdcList';
export * from './report/SalesOrderReports/designSoReport/addcounterDC';
export * from './report/SalesOrderReports/designSoReport/counterTransfer';
export * from './report/SalesOrderReports/designSoReport/addcounterTransfer';
export * from './Purchase/poplan/addpoplainplan';
export * from './Purchase/poplan/plainpoEstimate';
export * from './master/YearlysalesPlanMasterReport/YearlysalesPlanMasterReport';
export * from './Purchase/sample/dSample';
export * from './Purchase/sample/AddEditDSample';
export * from './Purchase/sample/dStock';
export * from './Purchase/sample/AddEditDStock';
export * from './master/customerDelivery/custDeliveryReport';
export * from './report/SalesOrderReports/designSoReport/designSostatusReport';
export * from './Sales/salesOrder/openOrderConvertion';
export * from './master/addsetmaster';
export * from './Purchase/sample/AddEditbagging';
export * from './Purchase/sample/AddEditExistSetbagging';
 export * from './master/bagMaster/addBagmaster';
  export * from './master/bagMaster/bagMaster';
export * from './master/addItemtype'
export * from './master/addWarehouse'
 export * from './master/RackMaster/addRackmaster';
  export * from './master/RackMaster/RackMaster';
  export * from './master/addopenStockset';
  export * from './master/addcolorGroup';
export * from './report/SalesOrderReports/partyOrderReport/partyPendingOrdreport';
  export * from './salesReports/openingStockreport';
  export * from './master/RackAllocation/rackAllocation';
  export * from './master/RackAllocation/addRackallocation';
export * from './report/BaggingRackingReports/baggingStockreport';
  export * from './report/BaggingRackingReports/rgrnBagpending';
  export * from './report/BaggingRackingReports/rackPendingreport';
  export * from './report/BaggingRackingReports/draftedRackreport';



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/index.ts